import React, { useEffect, useState } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PrApprovalView = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const user = localStorage.getItem("username");
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////     
            //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("Prior Purchase Approval", "view");
            const canEntry = hasPermission("Prior Purchase Approval", "entry");
            /////////////////////////////////////////////////////////////
       
  // ✅ Common fetch function
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://rfs2.infraconsoft.net.in/api/prPurchase_approval");
      setData(res.data.appList);
      setFilteredData(res.data.appList);
    } catch (err) {
      console.error("Error fetching appList:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Run once on mount
  useEffect(() => {
    fetchData();
  }, []);

  // Approve handler
  const handleApprove = async (prHeader_number) => {
    if (!prHeader_number) return;

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to approve this bill?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {

         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
        const response = await axios.put(
          "https://rfs2.infraconsoft.net.in/api/purchaseReq_appovalForPurchase",
          { prHeader_number, user }
        );

        if (response.data.success) {
          Swal.fire({
            title: "Approved!",
            text: "Request Approved Successfully!",
            icon: "success",
          });

          // ✅ reload data after approval
          fetchData();
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Failed to Approve.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error approving bill:", error);
        Swal.fire({
          title: "Error!",
          text: "Error processing approval.",
          icon: "error",
        });
      }
    }
  };

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.prDetail_number || "").toLowerCase().includes(term) || 
    String(item.supplierMaster_name || "").toLowerCase().includes(term) || 
    String(item.suppliermaster_code || "").toLowerCase().includes(term) 
    );

    setFilteredData(filtered);
};


  
  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Prior Purchase Approval</h2>
          <div>
            <Time />
          </div>
        </section>

      {canEntry && (
        <div className="next-container">
          <Link to={`/inventory/purchaseOrderView`}>
            <button className="next-btn">
              Next Purchase Order <i className="fa-solid fa-arrow-right"></i>
            </button>
          </Link>
        </div>
      )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by PR No / Supplier"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Type</th>
                <th>Pr No</th>
                <th>Date</th>
                <th>Supplier</th>
                <th>Supplier Name</th>
                <th>Value</th>
                {canEntry && (
                <th>Approval</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                <>
                  {currentData.map((item, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.branchCode}</td>
                      <td>{item.prHeader_Type}</td>
                      <td>
                        <Link
                          to={`/inventory/prViewSingle/${item.prDetail_number}`}
                        >
                          {item.prDetail_number}
                        </Link>
                      </td>
                      <td>
                        {item.prHeader_date
                          ? new Date(item.prHeader_date)
                              .toISOString()
                              .split("T")[0]
                          : ""}
                      </td>
                      <td>{item.suppliermaster_code}</td>
                      <td>{item.supplierMaster_name}</td>
                      <td>{item.price}</td>
                      {canEntry && (
                      <td>
                        <button
                          className="approve-btn"
                          onClick={() => handleApprove(item.prHeader_number)}
                        >
                          ✅ Approve
                        </button>
                      </td>
                      )}
                    </tr>
                  ))}

                  {/* Total Value Row */}
                  <tr>
                    <td colSpan={7}>
                      <strong>Total Value</strong>
                    </td>
                    <td>
                      <strong>
                        {currentData
                          .reduce((total, item) => total + item.price, 0)
                          .toFixed(2)}
                      </strong>
                    </td>
                    <td></td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="9">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map(
            (_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={currentPage === index + 1 ? "active" : ""}
              >
                {index + 1}
              </button>
            )
          )}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredData.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrApprovalView;
